export async function getBackAPIUrl() {
  const isBrowser = typeof window !== "undefined";
  if (isBrowser) {
    return process.env.NEXT_PUBLIC_CLUB_API_URL;
  }
  return process.env.BACK_API_URL;
}
